var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M23.6842 15.4395C24.1053 15.6886 24.1053 16.3114 23.6842 16.5605L12.9474 22.9123C12.5263 23.1614 12 22.8501 12 22.3519V9.64813C12 9.14994 12.5263 8.83858 12.9474 9.08767L23.6842 15.4395Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }